import { AdbReverseNotSupportedError } from "@yume-chan/adb";
import { delay } from "@yume-chan/async";
import { TransformStream } from "@yume-chan/stream-extra";
export class AdbScrcpyConnection {
    adb;
    options;
    constructor(adb, options) {
        this.adb = adb;
        this.options = options;
    }
    initialize() {
        // do nothing
    }
    dispose() {
        // do nothing
    }
}
export class AdbScrcpyForwardConnection extends AdbScrcpyConnection {
    _disposed = false;
    connect() {
        return this.adb.createSocket("localabstract:scrcpy");
    }
    async connectAndRetry() {
        for (let i = 0; !this._disposed && i < 100; i += 1) {
            try {
                return await this.connect();
            }
            catch (e) {
                await delay(100);
            }
        }
        throw new Error(`Can't connect to server after 100 retries`);
    }
    async connectVideoStream() {
        const { readable: videoStream } = await this.connectAndRetry();
        if (this.options.sendDummyByte) {
            const reader = videoStream.getReader();
            const { done, value } = await reader.read();
            // server will write a `0` to signal connection success
            if (done || value.byteLength !== 1 || value[0] !== 0) {
                throw new Error("Unexpected response from server");
            }
            reader.releaseLock();
        }
        return videoStream;
    }
    async getStreams() {
        const videoStream = await this.connectVideoStream();
        let controlStream;
        if (this.options.control) {
            controlStream = await this.connectAndRetry();
        }
        // Server only writes device meta after control socket is connected (if enabled)
        if (this.options.sendDeviceMeta) {
            const reader = videoStream.getReader();
            const { done, value } = await reader.read();
            // 64 bytes device name + 2 bytes video width + 2 bytes video height
            if (done || value.byteLength !== 64 + 2 + 2) {
                throw new Error("Unexpected response from server");
            }
            reader.releaseLock();
        }
        return [videoStream, controlStream];
    }
    dispose() {
        super.dispose();
        this._disposed = true;
    }
}
export class AdbScrcpyReverseConnection extends AdbScrcpyConnection {
    streams;
    address;
    async initialize() {
        try {
            // try to unbind first
            await this.adb.reverse.remove("localabstract:scrcpy");
        }
        catch (e) {
            if (e instanceof AdbReverseNotSupportedError) {
                throw e;
            }
            // Ignore other errors when unbinding
        }
        const queue = new TransformStream();
        this.streams = queue.readable.getReader();
        const writer = queue.writable.getWriter();
        this.address = await this.adb.reverse.add("localabstract:scrcpy", "tcp:27183", (socket) => {
            void writer.write(socket);
            return true;
        });
    }
    async accept() {
        return (await this.streams.read()).value;
    }
    async getStreams() {
        const { readable: videoStream } = await this.accept();
        let controlStream;
        if (this.options.control) {
            controlStream = await this.accept();
        }
        // Server only writes device meta after control socket is connected (if enabled)
        if (this.options.sendDeviceMeta) {
            const reader = videoStream.getReader();
            const { done, value } = await reader.read();
            // 64 bytes device name + 2 bytes video width + 2 bytes video height
            if (done || value.byteLength !== 64 + 2 + 2) {
                throw new Error("Unexpected response from server");
            }
            reader.releaseLock();
        }
        return [videoStream, controlStream];
    }
    dispose() {
        // Don't await this!
        // `reverse.remove`'s response will never arrive
        // before we read all pending data from `videoStream`
        this.adb.reverse.remove(this.address).catch((e) => {
            void e;
        });
    }
}
//# sourceMappingURL=connection.js.map